module.exports = __webpack_public_path__ + "static/media/YM78_6.3de722dc.jpg";